/** 角色卡社区页布局工具（T07b）：画布坐标 -> 内容区绝对定位样式。 */
import type { CSSProperties } from 'react';

import type { BoxLayout } from '../../ui';

/** 内容区在画布中的 y 偏移，与 App.tsx 的 app.content 保持一致。 */
export const CONTENT_TOP = 24;

/** 画布坐标 -> 内容区内的绝对定位样式。 */
export function contentBoxStyle(layout: BoxLayout): CSSProperties {
  return {
    position: 'absolute',
    left: layout.x,
    top: layout.y - CONTENT_TOP,
    width: layout.width,
    height: layout.height,
  };
}

/** 画布坐标 -> 相对某个已定位父级的绝对定位样式（父级同为画布坐标）。 */
export function offsetBoxStyle(layout: BoxLayout, parent: BoxLayout): CSSProperties {
  return {
    position: 'absolute',
    left: layout.x - parent.x,
    top: layout.y - parent.y,
    width: layout.width,
    height: layout.height,
  };
}